<app-us-legal-content
  [pageData]="pageData"
></app-us-legal-content>
<app-us-legal-support
  [pageData]="pageData"
></app-us-legal-support>
